import { CLOSE_DRAWER_ACTION, THD_DOMAIN_REGEX } from '../common/constants';
import CustomDrawer from './custom-drawer/CustomDrawer';
const { React, ReactDOM } = window;

// React 19 removed ReactDOM.render. Use createRoot when it's available
// (React 18/19), reusing a single root per container — calling createRoot more
// than once on the same node warns/leaks. Fall back to legacy render on React 16.
// The root is stashed on the container node so it's shared across open/close
// cycles and across Drawer instances that target the same container id.
function renderCompat(container, element) {
  if (!container) return;
  if (typeof ReactDOM.createRoot === 'function') {
    if (!container.__thdReactRoot) {
      container.__thdReactRoot = ReactDOM.createRoot(container);
    }
    container.__thdReactRoot.render(element);
  } else {
    ReactDOM.render(element, container);
  }
}

export default class Drawer {
  constructor({ hidden = false, src }) {
    this._containerId = 'thd-drawer-container';
    this.close = this.close.bind(this);
    this.hidden = hidden;
    this.src = src;
  }

  _addCloseDrawerEventListener() {
    const eventListenerFunc = (event) => {
      if (!THD_DOMAIN_REGEX.test(event.origin)) {
        return;
      }
      if (event.data.action === CLOSE_DRAWER_ACTION) {
        this.close();
      }
    };
    window.addEventListener('message', eventListenerFunc, false);
  }

  close() {
    renderCompat(document.getElementById(this._containerId), <div></div>);
    document.body.style.overflow = 'visible';
    this.isOpen = false;
  }

  open(message) {
    let drawerContainer = document.getElementById(this._containerId);
    if (!drawerContainer) {
      drawerContainer = document.createElement('div');
      drawerContainer.id = this._containerId;
    } 
    document.getElementsByTagName('body')[0].appendChild(drawerContainer);

    if (!this.hidden) {
      document.body.style.overflow = 'hidden';
    }
    renderCompat(
      document.getElementById(this._containerId),
      <CustomDrawer
        close={this.close}
        hidden={this.hidden}
        postMessage={this.postMessage.bind(this, message)}
        src={this.src}
      />
    );
    this.isOpen = true;
    this._addCloseDrawerEventListener();
  }

  postMessage(message) {
    if (!message) return;
    const trans = '*';
    const iframe = document.getElementById('thd-drawer-frame');
    iframe.contentWindow.postMessage(message, trans);
  }
}